import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a7099d24")

_pushScopeId("data-v-a7099d24")
const _hoisted_1 = {
  class: "toc_ui__baseInfo_main",
  id: "carInfo"
}
const _hoisted_2 = { class: "toc_ui__baseInfo_body" }
const _hoisted_3 = { class: "toc_ui__baseInfo_body_cont" }
const _hoisted_4 = { class: "ui__comTitle_main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "Vehicle Information", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("View More")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "jian-tou" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "infoList_main"
}
const _hoisted_9 = { class: "infoList_item" }
const _hoisted_10 = { class: "infoList_item_value" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("This mileage reading is recorded solely from the odometer display at the time of inspection.")
const _hoisted_13 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_14 = { class: "infoList_item_label" }
const _hoisted_15 = {
  key: 0,
  class: "split-line"
}
const _hoisted_16 = {
  key: 1,
  class: "infoList_main"
}
const _hoisted_17 = { class: "infoList_item" }
const _hoisted_18 = { class: "infoList_item_value" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("This mileage reading is recorded solely from the odometer display at the time of inspection.")
const _hoisted_21 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_22 = { class: "infoList_item_label" }
const _hoisted_23 = {
  key: 0,
  class: "split-line"
}
const _hoisted_24 = { class: "toc_ui__baseInfo_imgList" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("More")
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "jian-tou" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", {
            class: "titleSlot",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goCarInfo && _ctx.goCarInfo(...args)))
          }, [
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        (_ctx.state.baseInfo.length)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.baseInfo, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "infoList_main_cont",
                  key: item.code
                }, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      (item.value)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: ["infoList_item_value_txt", {'mile': item.code === 'mileage' || item.code === 'mileageKilometers'}]
                          }, [
                            _createTextVNode(_toDisplayString(item.value) + " ", 1),
                            (item.code === "mileage" || item.code === "mileageKilometers")
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "qs",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {_ctx.state.showTip = true}, ["stop"]))
                                }, [
                                  _createVNode("img", {
                                    src: require('@/assets/promiseFrame/question.png')
                                  }, null, 8, ["src"]),
                                  _withDirectives(_createVNode("span", null, [
                                    _hoisted_11,
                                    _hoisted_12
                                  ], 512), [
                                    [_vShow, _ctx.state.showTip]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : (_openBlock(), _createBlock("div", _hoisted_13, "-"))
                    ]),
                    _createVNode("div", _hoisted_14, _toDisplayString(item.name), 1)
                  ]),
                  (index % 2 === 0 && index !== _ctx.state.baseInfo.length - 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_15))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.configInfo.length)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.configInfo, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "infoList_main_cont",
                  key: item.code
                }, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      (item.value)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: ["infoList_item_value_txt", {'mile': item.code === 'mileage' || item.code === 'mileageKilometers'}]
                          }, [
                            _createTextVNode(_toDisplayString(item.value) + " ", 1),
                            (item.code === "mileage" || item.code === "mileageKilometers")
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "qs",
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {_ctx.state.showTip = true}, ["stop"]))
                                }, [
                                  _createVNode("img", {
                                    src: require('@/assets/promiseFrame/question.png')
                                  }, null, 8, ["src"]),
                                  _withDirectives(_createVNode("span", null, [
                                    _hoisted_19,
                                    _hoisted_20
                                  ], 512), [
                                    [_vShow, _ctx.state.showTip]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : (_openBlock(), _createBlock("div", _hoisted_21, "-"))
                    ]),
                    _createVNode("div", _hoisted_22, _toDisplayString(item.name), 1)
                  ]),
                  (index % 2 === 0 && index !== _ctx.state.configInfo.length - 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_23))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("ul", _hoisted_24, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0, 5), (item, index) => {
            return (_openBlock(), _createBlock("li", {
              class: "toc_ui__baseInfo_imgList_item",
              key: index
            }, [
              _createVNode("img", {
                class: "toc_ui__baseInfo_imgList_item",
                src: item.additionUrl,
                onClick: ($event: any) => (_ctx.goToImgView(item))
              }, null, 8, ["src", "onClick"]),
              (_ctx.state.photoList.length > 5 && index === 4)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "more",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToImgView("all")))
                  }, [
                    _hoisted_25,
                    _hoisted_26
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})